var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpsizeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.4998C8.4233 21.4998 6.39323 20.8839 4.66652 19.7302C2.9398 18.5764 1.59399 16.9366 0.79927 15.0179C0.00454947 13.0993 -0.203386 10.9881 0.201759 8.95131C0.606904 6.91451 1.60693 5.04359 3.07538 3.57514C4.54384 2.10669 6.41476 1.10666 8.45156 0.701515C10.4884 0.29637 12.5996 0.504305 14.5182 1.29903C16.4368 2.09375 18.0767 3.43956 19.2304 5.16627C20.3842 6.89299 21 8.92306 21 10.9998C20.9968 13.7836 19.8896 16.4524 17.9211 18.4209C15.9527 20.3893 13.2838 21.4966 10.5 21.4998ZM10.5 3.49976C9.01665 3.49976 7.5666 3.93963 6.33323 4.76374C5.09986 5.58785 4.13857 6.75919 3.57091 8.12964C3.00325 9.50008 2.85473 11.0081 3.14412 12.4629C3.4335 13.9178 4.14781 15.2542 5.1967 16.3031C6.2456 17.352 7.58197 18.0663 9.03683 18.3557C10.4917 18.645 11.9997 18.4965 13.3701 17.9289C14.7406 17.3612 15.9119 16.3999 16.736 15.1665C17.5601 13.9332 18 12.4831 18 10.9998C17.9976 9.01137 17.2067 7.1051 15.8007 5.69909C14.3947 4.29308 12.4884 3.50214 10.5 3.49976Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsizeImage);
export default __webpack_public_path__ + "static/media/upsizeImage.819a7de891f5c3972cbb598fa0c1dacd.svg";
export { ForwardRef as ReactComponent };